import React, { useState, useEffect } from 'react';
import styles from './terminal.module.scss';

const SpiderMan = ({ onTerminalDisappear }) => {
    const [showCommand, setShowCommand] = useState(false);
    const [showOutput, setShowOutput] = useState(false);
    const [hideTerminal, setHideTerminal] = useState(false);

    useEffect(() => {
        const commandTimer = setTimeout(() => {
            setShowCommand(true);
        }, 500); // Start typing the first line after the terminal lands

        const outputTimer = setTimeout(() => {
            setShowOutput(true);
        }, 2000); // Start typing the second line immediately after the first line finishes

        const fadeOutTimer = setTimeout(() => {
            setHideTerminal(true); // Fade out the terminal
        }, 4000); // Keep the terminal visible for 2 seconds after typing finishes

        const removeTimer = setTimeout(() => {
            if (onTerminalDisappear) onTerminalDisappear(); // Trigger parent callback
        }, 5000); // Trigger parent after fade-out completes

        return () => {
            clearTimeout(commandTimer);
            clearTimeout(outputTimer);
            clearTimeout(fadeOutTimer);
            clearTimeout(removeTimer);
        };
    }, [onTerminalDisappear]);

    return (
        <div className={`${styles.wrapper} ${hideTerminal ? styles.hidden : ''}`}>
            <div className={`${styles.terminal} ${hideTerminal ? styles.fadeOut : styles.dropIn}`}>
                <div className={styles.terminalHeader}>
                    <div className={styles.dot}></div>
                    <div className={styles.dot}></div>
                    <div className={styles.dot}></div>
                </div>
                <div className={styles.terminalBody}>
                    <pre>
                        <code>
                            {showCommand && (
                                <span className={styles.typing}>
                                    mansi@portfolio:~$ npm start
                                </span>
                            )}
                            <br />
                            {showOutput && (
                                <span className={styles.typing}>
                                    &gt; Starting dev server...
                                </span>
                            )}
                        </code>
                    </pre>
                </div>
            </div>
        </div>
    );
};

export default SpiderMan;
